var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcSwitch(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "42px",
    height: "36px",
    viewBox: "0 0 42 36",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ic_swicth") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M353.713224,2328.75 L353.713224,2331 L349.130947,2326.5 L353.713224,2322 L353.713224,2324.25 L360.569499,2324.25 L360.569499,2324.25 C364.356127,2324.25088 367.426488,2321.22951 367.427381,2317.50158 C367.427886,2315.38563 366.420519,2313.39189 364.706115,2312.11575 L364.731255,2312.08425 L367.953704,2308.91175 L367.953703,2308.91175 C372.771558,2312.92501 373.372553,2320.02352 369.296094,2324.76666 C367.124183,2327.29378 363.931952,2328.75091 360.569485,2328.75 L353.710924,2328.75225 L353.713224,2328.75 Z M358.284074,2306.25 L358.284074,2304 L362.962339,2308.5 L358.284074,2313 L358.284074,2310.75 L351.427799,2310.75 L351.4278,2310.75 C347.641172,2310.74997 344.571489,2313.77202 344.571454,2317.49993 C344.571434,2319.61666 345.579994,2321.61082 347.295744,2322.8865 L344.043585,2326.086 L344.043584,2326.086 C339.227016,2322.07126 338.628234,2314.97258 342.706182,2310.23067 C344.877479,2307.70585 348.067503,2306.24986 351.427792,2306.25 L358.286352,2306.25 L358.284074,2306.25 Z",
    id: "path-1"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-31.2%",
    y: "-18.5%",
    width: "162.5%",
    height: "174.1%",
    filterUnits: "objectBoundingBox",
    id: "filter-2"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 5,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.0156862754   0 0 0 0 0.768627465   0 0 0 0 0.725490212  0 0 0 0.300000012 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u9875\\u9762-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u5207\\u56FE",
    transform: "translate(-335.000000, -2304.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ic_swicth"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-2)",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#00cfff",
    xlinkHref: "#path-1"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSwitch);
export default __webpack_public_path__ + "static/media/ic_switch.46a99275cf9f13f21ec2be9dbfbc9fcf.svg";
export { ForwardRef as ReactComponent };